<template>
    <dialog-modal :closeable="false" :show="show" type="danger" @close="$emit('close')">
        <template #title>{{ trans('workorder.modal.confirm_delete.title') }} </template>

        <div>{{ trans('workorder.modal.confirm_delete.description') }}</div>
        <div class="text-large my-3 text-center">
            {{ form.workOrder?.code }}
        </div>
        <div class="d-flex align-items-start gap-2 text-danger">
            <icon color="danger" icon="cil-warning" style="height: 22px" />
            <div>{{ trans('workorder.modal.confirm_delete.warning') }}</div>
        </div>

        <template #footer>
            <jet-button type="button" variant="tertiary" @click.stop="closeModal">{{ trans('general.action.cancel') }} </jet-button>
            <jet-button :is-processing="form.processing" color="danger" @click.stop="deleteWorkOrder">
                {{ trans('general.action.delete') }}
            </jet-button>
        </template>
    </dialog-modal>
</template>

<script>
import JetButton from '@/Jetstream/Button.vue';
import DialogModal from '@/Jetstream/DialogModal.vue';
import { eventBus, events } from '@/eventBus.js';
import { $http } from '@/bootstrap.js';
import { trans } from '@/mixins/i18n.js';

export default {
    components: {
        DialogModal,
        JetButton,
    },
    data() {
        return {
            shouldRender: false,
            show: false,
            form: this.$inertia.form({ workOrder: null }),
            onDeleting: null,
            onDeleted: null,
            onError: null,
        };
    },

    mounted() {
        eventBus.$on(events.openDeleteWorkOrderModal, (event) => {
            this.form.workOrder = event.workOrder;
            this.onDeleting = event.onDeleting || null;
            this.onDeleted = event.onDeleted || null;
            this.onError = event.onError || null;

            this.shouldRender = true;
            this.$nextTick(() => {
                this.show = true;
            });
        });
    },
    beforeUnmount() {
        eventBus.$off(events.openDeleteWorkOrderModal);
    },
    methods: {
        deleteWorkOrder() {
            if (!this.form.workOrder) {
                return;
            }

            this.onDeleting && this.onDeleting(this.form.workOrder);

            this.form.processing = true;

            $http
                .delete(route('workorders.destroy', this.form.workOrder))
                .then(() => {
                    this.onDeleted && this.onDeleted(this.form.workOrder);
                    this.closeModal();
                })
                .catch((error) => {
                    eventBus.$emit(events.presentFlashMessage, {
                        payload: {
                            message: error.response?.data?.message ?? trans('general.error.unknown'),
                            status: 'error',
                        },
                    });
                    this.onError && this.onError(this.form.workOrder);
                })
                .finally(() => {
                    this.form.processing = false;
                });
        },
        closeModal() {
            this.show = false;
            setTimeout(() => {
                this.shouldRender = false;
            }, 300);

            this.form.workOrder = null;
            this.onDeleting = null;
            this.onDeleted = null;
            this.onError = null;
        },
    },
};
</script>
